import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Main2020() {
  const handleDownload1 = () => {
    window.open("assets/2020/Stephan Lalremthara.pdf", "_blank");
  };
  const handleDownload2 = () => {
    window.open("assets/2020/Lalzuiliana.pdf", "_blank");
  };
  const handleDownload3 = () => {
    window.open(
      "assets/2020/Lalhmangaihsangi Ralte & Vanlalchhawna.pdf",
      "_blank"
    );
  };
   const handleDownload4 = () => {
    window.open("assets/2020/Lalrinkima.pdf", "_blank");
  };
    const handleDownload5 = () => {
    window.open("assets/2020/Lalengkima.pdf", "_blank");
  };
  const handleDownload6 = () => {
    window.open("assets/2020/Thelma Lalhmingthangi.pdf", "_blank");
  };
  const handleDownload7 = () => {
    window.open("assets/2020/K Vanrammawia.pdf", "_blank");
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
       <main className=" h-full justify-center items-center flex mx-20">
        <div className="flex flex-col-reverse lg:flex-row  justify-center items-center">
          {/* Book Cover */}
          <div className=" mr-20 sm:mt-0 md:mt-20 mt-20 flex flex-col justify-center items-center">
            <img className="h-96 w-60" src="mea.webp" />
            <div className=" text-center font-semibold">ISSN 2581-7523</div>
          </div>
          {/* Main Page */}
          <div className="">
            <div className="">
              <div className=" font-bold text-xl">Mizoram Economic Review</div>
              <div className="text-sm">Volume 3, No. 1 (2020)</div>
              <div className="text-sm">ISSN 2581-7523</div>
            </div>

            {/* Content */}
            <div className="mt-10 grid grid-row-1 gap-6">
              <button className="text-left" onClick={handleDownload1}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Performances of MGNREGS in Aibawk R.D Block
                </div>
                <div className="text-sm text-green-600">
                  Stephan Lalremthara
                </div>
              </button>
              <button className="text-left" onClick={handleDownload2}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Performance Analysis of Microfinance Institutions in Aizawl City, Mizoram, India
                </div>
                <div className="text-sm text-green-600">
                  Lalzuiliana
                </div>
              </button>
              <button className="text-left" onClick={handleDownload3}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                 Profitability of Dairy Farming in Aizawl District, Mizoram
                </div>
                <div className="text-sm text-green-600">Lalhmangaihsangi Ralte & Vanlalchhawna</div>
              </button>
              <button className="text-left" onClick={handleDownload4}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Assymetry of Information and its Impact on Patients' Satisfaction Regarding Healthcare: A Case Study of Civil Hospital, Aizawl
                </div>
                <div className="text-sm text-green-600">Lalrinkima</div>
              </button>
              <button className="text-left" onClick={handleDownload5}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Grapes Cultivation in Champhai Cluster, Mizoram: A Case Study
                </div>
                <div className="text-sm text-green-600">Lalengkima</div>
              </button>
              <button className="text-left" onClick={handleDownload6}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Determinants of Consumer Preferences of Cellular Services in Mizoram
                </div>
                <div className="text-sm text-green-600">Thelma Lalhmingthangi</div>
              </button>
              <button className="text-left" onClick={handleDownload7}>
                <div className="font-bold hover:text-blue-400 text-blue-600">
                  Public Interventions in Agricultural Marketing in Mizoram
                </div>
                <div className="text-sm text-green-600">
                  K Vanrammawia
                </div>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
